module.exports = __webpack_public_path__ + "img/isbar3.bd5c437e.png";